import React from 'react'
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import Explore from './pages/Explore'
import Offers from './pages/Offers'
import Profile from './pages/Profile'
import SignIn from './pages/SignIn'
import SignUp from './pages/SignUp'
import Category from './pages/Category'
import ForgotPassword from './pages/ForgotPassword'
import Navbar from './components/Navbar'
import PrivateRoute from './components/PrivateRoute';
import CreateListings from './pages/CreateListings';
import Listing from './pages/Listing'
import Contact from './pages/Contact';
import EditListings from './pages/EditListings';



function App() {
  return (
    <>
      <Router>

        <Routes>

          <Route path='/' element={<Explore/>}/> 
          <Route path='/offers' element={<Offers/>}/> 
          <Route path='/category/:categoryName' element={<Category/>}/>
          <Route path='/profile' element={<PrivateRoute/>}>
          <Route path = '/profile' element = {<Profile/>}/> 
          </Route>
          <Route path='/sign-in' element={<SignIn/>}/> 
          <Route path='/sign-up' element={<SignUp/>}/> 
          <Route path='/forgot-password' element={<ForgotPassword/>}/> 
          <Route path='/create-listings' element={<CreateListings/>}/>
          <Route path='/edit-listing/:listingId' element={<EditListings/>}/>
          <Route path = '/category/:categoryName/:listingId' element={<Listing/>}/>
          <Route path = '/contact/:landlordId' element={<Contact/>}/>

        </Routes>

        <Navbar/>

      </Router>

      <ToastContainer/>
    </>
  );
}

export default App;
